import {ComponentProps} from "react";
import classNames from "classnames";
import {useOpenBuyOneClick} from "@/features/buyOneClick/model/useOpenBuyOneClick";
import {Button} from "@/shared/ui/Button";
import styles from "./BuyOneClickButton.module.scss";

type Props = Omit<ComponentProps<typeof Button>, "loading" | "children" | "onClick" | "variant"> & {
    productId: number;
    selectedSize: string;
};

export const BuyOneClickButton = ({productId, selectedSize, className, labelClassName, ...buttonProps}: Props) => {
    const {openBuyOneClick, loading} = useOpenBuyOneClick();

    return (
        <Button
            {...buttonProps}
            variant={`secondary`}
            loading={loading}
            className={classNames(styles.button, className)}
            labelClassName={classNames(styles.label, labelClassName)}
            onClick={() => openBuyOneClick(productId, selectedSize)}
        >
            Купить в 1 клик
        </Button>
    );
}
